module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAICAYAAAAm06XyAAAAAXNSR0IArs4c6QAAAOFJREFUKFNjTPIxb2dkYKhgIBH8Z2DoYATpSfIym87IxJhBrP7///7PmLftVCZYMwMDA1Oyj9liBgbGKMIG/F82d8upWAYGhn8wzQwODg4syjzf1jEwMPriNuD/5rtfuIIOHDjwB6QGrhnESXBQ4GDiFtvGyMjoiG7A////9//7+sprwYEHP2ByKJrB/vdT52X4x7+XkYHRFKboP8P/0wxMH53nbbr5GdlQDM0gyThnM2FWDoaDDIyM2gz//1/9/YPBftHeU2/RXYNVM9gFroZSDGxsCxl+/Yqft/v8M2zhAACRQUN1zgR4EAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bookIcons/smalldown.png
// module id = qHpA
// module chunks = 1